var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoxtz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2079_21324)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 8.36881L13.818 0.738281L27.0345 8.36881V23.6299L13.818 31.2604L0.601562 23.6299V8.36881Z",
    stroke: "url(#paint0_linear_2079_21324)",
    strokeWidth: 1.45455
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2079_21324",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8178 2.87109L25.1864 9.43473V22.562L13.8178 29.1256L2.44922 22.562V9.43473L13.8178 2.87109Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2079_21324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8182 29.818C21.4498 29.818 27.6364 23.6314 27.6364 15.9998C27.6364 8.36825 21.4498 2.18164 13.8182 2.18164C6.18661 2.18164 0 8.36825 0 15.9998C0 23.6314 6.18661 29.818 13.8182 29.818Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 16.9336V16.8438C4.35938 16.5391 4.40365 16.2565 4.49219 15.9961C4.58073 15.7331 4.70833 15.5052 4.875 15.3125C5.04167 15.1172 5.24349 14.9661 5.48047 14.8594C5.71745 14.75 5.98307 14.6953 6.27734 14.6953C6.57422 14.6953 6.84115 14.75 7.07812 14.8594C7.31771 14.9661 7.52083 15.1172 7.6875 15.3125C7.85677 15.5052 7.98568 15.7331 8.07422 15.9961C8.16276 16.2565 8.20703 16.5391 8.20703 16.8438V16.9336C8.20703 17.2383 8.16276 17.5208 8.07422 17.7812C7.98568 18.0417 7.85677 18.2695 7.6875 18.4648C7.52083 18.6576 7.31901 18.8086 7.08203 18.918C6.84766 19.0247 6.58203 19.0781 6.28516 19.0781C5.98828 19.0781 5.72135 19.0247 5.48438 18.918C5.2474 18.8086 5.04427 18.6576 4.875 18.4648C4.70833 18.2695 4.58073 18.0417 4.49219 17.7812C4.40365 17.5208 4.35938 17.2383 4.35938 16.9336ZM5.08203 16.8438V16.9336C5.08203 17.1445 5.10677 17.3438 5.15625 17.5312C5.20573 17.7161 5.27995 17.8802 5.37891 18.0234C5.48047 18.1667 5.60677 18.2799 5.75781 18.3633C5.90885 18.444 6.08464 18.4844 6.28516 18.4844C6.48307 18.4844 6.65625 18.444 6.80469 18.3633C6.95573 18.2799 7.08073 18.1667 7.17969 18.0234C7.27865 17.8802 7.35286 17.7161 7.40234 17.5312C7.45443 17.3438 7.48047 17.1445 7.48047 16.9336V16.8438C7.48047 16.6354 7.45443 16.4388 7.40234 16.2539C7.35286 16.0664 7.27734 15.901 7.17578 15.7578C7.07682 15.612 6.95182 15.4974 6.80078 15.4141C6.65234 15.3307 6.47786 15.2891 6.27734 15.2891C6.07943 15.2891 5.90495 15.3307 5.75391 15.4141C5.60547 15.4974 5.48047 15.612 5.37891 15.7578C5.27995 15.901 5.20573 16.0664 5.15625 16.2539C5.10677 16.4388 5.08203 16.6354 5.08203 16.8438ZM9.75094 13.3125L11.1181 15.4922L12.4853 13.3125H13.3642L11.5673 16.1289L13.4072 19H12.5205L11.1181 16.7773L9.71578 19H8.82906L10.6689 16.1289L8.87203 13.3125H9.75094ZM16.4198 13.3125V19H15.6777V13.3125H16.4198ZM18.248 13.3125V13.9297H13.8534V13.3125H18.248ZM22.9481 18.3867V19H19.0966V18.3867H22.9481ZM22.8231 13.8594L19.2762 19H18.8114V18.4375L22.3544 13.3125H22.8231V13.8594ZM22.5028 13.3125V13.9297H18.8622V13.3125H22.5028Z",
    fill: "black",
    fillOpacity: 0.67
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2079_21324",
    x1: -9.31078,
    y1: 15.9994,
    x2: 30.3386,
    y2: 15.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184658,
    stopColor: "#39E4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C7BCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2079_21324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6364,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxtz);
export default __webpack_public_path__ + "static/media/foxtz.27d942c33838fbaedf46e38e59922b10.svg";
export { ForwardRef as ReactComponent };